import React from 'react';

/**
 * Camera icon for `ParticipantTile`'s control row (`SF-05D-TILE-CONTROLS`).
 *
 * Same discipline as `IconMic`: inline `<svg>` on `currentColor`, never an emoji (design § D-E,
 * task 1.3), and `off` **adds** the `.ic-slash` line to the same glyph rather than swapping in a
 * second picture. `data-off` is emitted so the mockup's `.ic[data-off="no"] .ic-slash` selector
 * keeps working verbatim; the conditional render is what makes the state observable in jsdom, where
 * CSS-module rules never apply.
 *
 * Geometry is pinned by the task list 1.2: viewBox `0 0 24 24`, stroke width 1.9, round caps and joins.
 *
 * @component
 * @param {Object} props
 * @param {boolean?} props.off render the camera-off (slashed) variant
 * @returns {JSX.Element} SVG icon
 */
const IconCamera = props => {
  const { off = false } = props;

  return (
    <span className="ic" data-off={off ? 'yes' : 'no'} style={WRAPPER_STYLE}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="6" width="13" height="12" rx="2.5" />
        <path d="M15 10.5 21.5 7v10L15 13.5z" />
        {off ? <line className="ic-slash" x1="4" y1="4" x2="20" y2="20" /> : null}
      </svg>
    </span>
  );
};

/** The whole of the `.ic` wrapper rule — too small to earn a `.module.css` of its own (§ D-E). */
const WRAPPER_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
};

export default IconCamera;
